import dayjs from 'dayjs';
import { Calendar } from 'primereact/calendar';

import { ISO_DATE } from '@shared/lib/date';

import { SHARED_COMPONENTS_TEXT } from '../constants';

export interface BaseDatePickerProps {
  id: string;
  /** ISO `YYYY-MM-DD` (what the API speaks) or null. */
  value: string | null;
  onChange: (iso: string | null) => void;
  placeholder?: string;
  minDate?: string | null;
  maxDate?: string | null;
  invalid?: boolean;
  disabled?: boolean;
  'aria-label'?: string;
}

const toDate = (iso: string | null | undefined): Date | undefined =>
  iso ? dayjs(iso, ISO_DATE, true).toDate() : undefined;

/** Always shows MM-DD-YYYY (firm standard); always emits ISO. */
export function BaseDatePicker({
  id,
  value,
  onChange,
  placeholder = SHARED_COMPONENTS_TEXT.datePicker.placeholder,
  minDate,
  maxDate,
  invalid,
  disabled,
  'aria-label': ariaLabel,
}: BaseDatePickerProps) {
  return (
    <Calendar
      inputId={id}
      value={toDate(value) ?? null}
      onChange={(e) => {
        const d = e.value;
        onChange(d instanceof Date ? dayjs(d).format(ISO_DATE) : null);
      }}
      dateFormat="mm-dd-yy"
      placeholder={placeholder}
      minDate={toDate(minDate)}
      maxDate={toDate(maxDate)}
      invalid={invalid}
      disabled={disabled}
      showIcon
      showButtonBar
      // Name the text input itself (the one people type into), not the wrapper.
      pt={ariaLabel ? { input: { root: { 'aria-label': ariaLabel } } } : undefined}
      className="w-full"
      inputClassName="w-full"
    />
  );
}
